'use client';

import { __awaiter, __generator, __assign } from '../_virtual/_tslib.js';
import React__default, { useState, useEffect } from 'react';
import Button from '../Button/index.js';
import { apiServices } from './service.js';
import { isMobile } from '../Utils/helpers.js';
import { IconLoading, IconLinkedInSuccessMobile, IconLinkedInSuccess, IconLinkedIn, IconLinkedInButton, IconLinkElipse } from './images.js';
import closeIcon from '../Dialog/deleteIcon.js';
import { Wrapper, AlertContent, AlertContentText, AlertCancel, SuccessUploadCV, SuccessText, CloseIconWrapper, SuccessTextSpan, SuccessLink, Container, ContainerImage, ContainerSvgImage, ContainerContent, ContentTitle, ContentDesc, ContentButton, ContainerCloseIcon, ContentCVFile, ContentTextWrapper, ContentNormalText, ContentFileWrapper, ContentFileText, ContentFileTail } from './styles.js';
import translations from './translations.js';
import UploadDialog from './UploadDialog/index.js';
import GuideDialog from './GuideDialog/index.js';
import Alert from '../Alert/index.js';
import useHog from '../PostHog/hooks/useHog/index.js';
import '../Utils/constants.js';
import { DEFAULT_SUCCESS_CODE } from '../services/resumes/const.js';
import '../UploadResumeModal/type.js';
import { LOADING_STATUS, SUCCESS_STATUS, FAIL_STATUS, INIT_STATUS } from './constants.js';

function LinkedIn(props) {
    var _this = this;
    var _a = props.lang, lang = _a === void 0 ? 'vi' : _a, _b = props.type, type = _b === void 0 ? 'myprofile' : _b, tokenAccess = props.tokenAccess, apiCrawlStatus = props.apiCrawlStatus, apiUploadLinked = props.apiUploadLinked, resumeId = props.resumeId, baseUrl = props.baseUrl;
    var _c = useState(false), showLinkedIn = _c[0], setShowLinkedIn = _c[1];
    var _d = useState(''), showDialog = _d[0], setShowDialog = _d[1];
    var _e = useState(true), showDashboard = _e[0], setShowDashboard = _e[1];
    var _f = useState(true), showErrorMess = _f[0], setShowErrorMess = _f[1];
    var _g = useState(false), showLoading = _g[0], setShowLoading = _g[1];
    var _h = useState(true), showSuccessMyprofile = _h[0], setShowSuccessMyprofile = _h[1];
    var _j = useState(''), cvName = _j[0], setCvName = _j[1];
    var _k = useState(''), error = _k[0], setError = _k[1];
    var _l = useState(false), success = _l[0], setSuccess = _l[1];
    var _m = useState(''), userId = _m[0], setUserId = _m[1];
    var tracking = useHog().tracking;
    var t = function (text) {
        if (lang === 'en') {
            return text;
        }
        else {
            return translations[text];
        }
    };
    var getLocalStorage = function () {
        return JSON.parse(localStorage.getItem('VNW_LINKEDIN_SETTING') || '{}');
    };
    var saveLocalStorage = function (editItem) {
        var item = getLocalStorage();
        item[userId] = __assign(__assign({}, item[userId]), editItem);
        localStorage.setItem('VNW_LINKEDIN_SETTING', JSON.stringify(item));
    };
    var initLocalStorage = function (setting) {
        if (setting === void 0) { setting = {}; }
        setting[userId] = {
            showError: true,
            showSuccess: true,
            showSuccessMyprofile: true,
            reload: false
        };
        localStorage.setItem('VNW_LINKEDIN_SETTING', JSON.stringify(setting));
    };
    var handleReloadPage = function (isReload) {
        saveLocalStorage({ reload: isReload });
    };
    var handleShowError = function (isShow) {
        setShowErrorMess(isShow);
        saveLocalStorage({ showError: isShow });
        if (!isShow)
            setError('');
    };
    var handleShowSuccess = function (isShow) {
        if (type === 'dashboard') {
            setShowDashboard(isShow);
            saveLocalStorage({ showSuccess: isShow });
        }
        else {
            setShowSuccessMyprofile(isShow);
            saveLocalStorage({ showSuccessMyprofile: isShow });
        }
    };
    var checkStatusUpload = function (numberCrawApi) {
        if (numberCrawApi === void 0) { numberCrawApi = 0; }
        return __awaiter(_this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (tokenAccess === '') {
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, apiServices.getLinkedInStatus(apiCrawlStatus, tokenAccess)];
                    case 1:
                        response = _a.sent();
                        setUserId(String(response === null || response === void 0 ? void 0 : response.userId) || '');
                        if ((response === null || response === void 0 ? void 0 : response.statusId) && (response === null || response === void 0 ? void 0 : response.statusId) === LOADING_STATUS) {
                            // LOADING
                            setShowLoading(true);
                            setError('');
                            setTimeout(function () { return checkStatusUpload(numberCrawApi + 1); }, 5000);
                        }
                        else if ((response === null || response === void 0 ? void 0 : response.statusId) && (response === null || response === void 0 ? void 0 : response.statusId) === SUCCESS_STATUS) {
                            // SUCCESS
                            setShowLoading(false);
                            setCvName(response === null || response === void 0 ? void 0 : response.latestSuccessFileName);
                            setSuccess(true);
                            setShowLinkedIn(false);
                            tracking({
                                eventName: 'js_profile_management:sync_linkedin_profile_sucess',
                                properties: {
                                    isDashboard: type === 'dashboard'
                                }
                            });
                        }
                        else if ((response === null || response === void 0 ? void 0 : response.statusId) && (response === null || response === void 0 ? void 0 : response.statusId) === FAIL_STATUS) {
                            // FAIL
                            setSuccess(true);
                            setShowLoading(false);
                            setError('');
                            setCvName(response === null || response === void 0 ? void 0 : response.latestSuccessFileName);
                            tracking({
                                eventName: 'js_profile_management:sync_linkedin_profile_sucess',
                                properties: {
                                    isDashboard: false
                                }
                            });
                            if ((response === null || response === void 0 ? void 0 : response.userId) === undefined) {
                                handleReloadPage(false);
                                return [2 /*return*/];
                            }
                            if (getLocalStorage()[response === null || response === void 0 ? void 0 : response.userId].reload && numberCrawApi !== 0) {
                                handleReloadPage(false);
                                setTimeout(function () { return location.reload(); }, 1500);
                            }
                        }
                        else if ((response === null || response === void 0 ? void 0 : response.statusId) && (response === null || response === void 0 ? void 0 : response.statusId) === INIT_STATUS) {
                            // FIRST IMPORT - NEW ACCOUNT
                            setShowLinkedIn(true);
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    var uploadLinkedInCV = function (cv) { return __awaiter(_this, void 0, void 0, function () {
        var response;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    // when upload new file CV, show error success is valid
                    handleShowError(true);
                    handleShowSuccess(true);
                    setSuccess(false);
                    return [4 /*yield*/, apiServices.uploadLinkedIn(apiUploadLinked, tokenAccess, cv, resumeId, lang)];
                case 1:
                    response = _b.sent();
                    if (response && response.meta.code && response.meta.code >= DEFAULT_SUCCESS_CODE && response.meta.code < 400) {
                        // SUCCESS
                        setSuccess(true);
                        setShowLoading(false);
                        setCvName(response === null || response === void 0 ? void 0 : response.data.data.latestSuccessFileName);
                        tracking({
                            eventName: 'js_profile_management:sync_linkedin_profile_sucess',
                            properties: {
                                isDashboard: type === 'dashboard'
                            }
                        });
                    }
                    else {
                        setError((_a = response === null || response === void 0 ? void 0 : response.meta.message) !== null && _a !== void 0 ? _a : '');
                        setShowLoading(false);
                        tracking({
                            eventName: 'js_profile_management:sync_linkedin_profile_error'
                        });
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var handleImportButton = function () {
        // reset error success when press import file button
        if (type === 'myprofile') {
            handleShowSuccess(false);
        }
        handleShowError(false);
        setShowDialog('guide');
        tracking({
            eventName: 'js_profile_management:sync_linkedin_profile_click'
        });
    };
    useEffect(function () {
        var _a, _b, _c;
        if (userId) {
            if (!localStorage.getItem('VNW_LINKEDIN_SETTING'))
                initLocalStorage();
            else if (!Object.keys(getLocalStorage()).includes(userId))
                initLocalStorage(getLocalStorage());
            else {
                setShowSuccessMyprofile((_a = getLocalStorage()[userId]) === null || _a === void 0 ? void 0 : _a.showSuccessMyprofile);
                setShowDashboard((_b = getLocalStorage()[userId]) === null || _b === void 0 ? void 0 : _b.showSuccess);
                setShowErrorMess((_c = getLocalStorage()[userId]) === null || _c === void 0 ? void 0 : _c.showError);
            }
        }
    }, [userId]);
    useEffect(function () {
        checkStatusUpload();
    }, [tokenAccess]);
    return (React__default.createElement(Wrapper, null,
        showLoading && !showDialog && (
        // Loading
        React__default.createElement(Alert, { type: 'warning', style: { padding: '10px', marginBottom: '10px' } },
            React__default.createElement(AlertContent, null,
                React__default.createElement(IconLoading, null),
                React__default.createElement(AlertContentText, null, t('It may take a few minutes to import the data...'))))),
        type === 'myprofile' && showErrorMess && error && !showDialog && (
        // Error myprofile
        React__default.createElement(Alert, { type: 'error', style: { padding: '10px', marginBottom: '10px' }, isHaveClose: false },
            React__default.createElement(AlertContent, null,
                error,
                React__default.createElement(AlertCancel, { onClick: function () { return handleShowError(false); } },
                    React__default.createElement(closeIcon, { style: { width: '20px' }, fill: '#7a7575' }))))),
        type === 'dashboard' && showErrorMess && error && showDashboard && !showDialog && (
        // Error dashboard
        React__default.createElement(Alert, { type: 'error', style: { padding: '10px', marginBottom: '10px' }, isHaveClose: false },
            React__default.createElement(AlertContent, null,
                error,
                React__default.createElement(AlertCancel, { onClick: function () { return handleShowError(false); } },
                    React__default.createElement(closeIcon, { style: { width: '20px' }, fill: '#7a7575' }))))),
        type === 'myprofile' && showSuccessMyprofile && success && !showDialog && (
        // Success myprofile
        React__default.createElement(SuccessUploadCV, null,
            isMobile() ? React__default.createElement(IconLinkedInSuccessMobile, null) : React__default.createElement(IconLinkedInSuccess, null),
            React__default.createElement(SuccessText, null, t("Your LinkedIn profile has been updated to VietnamWorks's profile successfully.")),
            React__default.createElement(CloseIconWrapper, { onClick: function () { return handleShowSuccess(false); } },
                React__default.createElement(closeIcon, { style: { width: '20px' }, fill: '#7a7575' })))),
        type === 'dashboard' && showDashboard && success && !showDialog && (
        // Success dashboard
        React__default.createElement(SuccessUploadCV, null,
            isMobile() ? React__default.createElement(IconLinkedInSuccessMobile, null) : React__default.createElement(IconLinkedInSuccess, null),
            React__default.createElement(SuccessText, null,
                t('Your LinkedIn profile has been updated to VietnamWorks’s profile successfully.'),
                ' ',
                React__default.createElement(SuccessTextSpan, null,
                    t('Go to'),
                    ' ',
                    React__default.createElement("a", { href: "".concat(baseUrl, "/").concat(t('my-profile')), onClick: function () { return handleShowSuccess(false); }, rel: 'noreferrer' },
                        React__default.createElement(SuccessLink, null, t('My Profile')),
                        ' '),
                    t('to review your updated profile.'))),
            React__default.createElement(CloseIconWrapper, { onClick: function () { return handleShowSuccess(false); } },
                React__default.createElement(closeIcon, { style: { width: '20px' }, fill: '#7a7575' })))),
        type === 'dashboard' && showDashboard && !success && showLinkedIn && (React__default.createElement(Container, { bgColor: '#D4E6F0' },
            React__default.createElement(ContainerImage, null,
                React__default.createElement(ContainerSvgImage, null,
                    React__default.createElement(IconLinkedIn, { backgroundColor: 'transparent' }))),
            React__default.createElement(ContainerContent, null,
                React__default.createElement(ContentTitle, null, t('Save time by importing your existing LinkedIn profile!')),
                React__default.createElement(ContentDesc, null, t('Your VietnamWorks profile information will be replaced with information from your LinkedIn account. For example skills, education, experience, etc. and you cannot undo.')),
                React__default.createElement(ContentButton, null,
                    React__default.createElement(Button, { type: 'info', size: 'md-h', onClick: handleImportButton, disabled: showLoading },
                        React__default.createElement(IconLinkedInButton, { style: { marginRight: '10px' } }),
                        showLoading ? t('File uploading') : t('Import profile'))),
                React__default.createElement(ContainerCloseIcon, { onClick: function () { return setShowLinkedIn(false); } },
                    React__default.createElement(closeIcon, { style: { width: '20px' }, fill: '#7a7575' }))))),
        type === 'myprofile' && !cvName && (
        // Upload CV from LinkedIn
        React__default.createElement(Container, null,
            React__default.createElement(ContainerImage, null,
                React__default.createElement(ContainerSvgImage, null,
                    React__default.createElement(IconLinkedIn, { backgroundColor: 'transparent' }))),
            React__default.createElement(ContainerContent, null,
                React__default.createElement(ContentTitle, null, t('Save time by importing your existing LinkedIn profile!')),
                React__default.createElement(ContentDesc, null, t('Your VietnamWorks profile information will be replaced with information from your LinkedIn account. For example skills, education, experience, etc. and you cannot undo.')),
                React__default.createElement(ContentButton, null,
                    React__default.createElement(Button, { type: 'info', size: 'md-h', style: { fontWeight: 'bold' }, onClick: handleImportButton, disabled: showLoading },
                        React__default.createElement(IconLinkedInButton, { style: { marginRight: '10px' } }),
                        showLoading ? t('File uploading') : t('Import profile')))))),
        type === 'myprofile' && cvName && (
        // Already have CV
        React__default.createElement(Container, null,
            React__default.createElement(ContainerImage, null,
                React__default.createElement(ContainerSvgImage, null,
                    React__default.createElement(IconLinkedIn, { backgroundColor: 'transparent' }))),
            React__default.createElement(ContainerContent, null,
                React__default.createElement(ContentTitle, null, t('Save time by importing your existing LinkedIn profile!')),
                React__default.createElement(ContentCVFile, null,
                    React__default.createElement(ContentTextWrapper, null,
                        React__default.createElement(ContentNormalText, null, t('Profile imported:')),
                        React__default.createElement(ContentFileWrapper, null,
                            React__default.createElement(IconLinkElipse, null),
                            React__default.createElement(ContentFileText, null, cvName.slice(0, cvName.length - 4)),
                            React__default.createElement(ContentFileTail, null, ".pdf"))),
                    React__default.createElement(ContentButton, { style: { marginTop: '10px', width: isMobile() ? '100%' : 'auto' } },
                        React__default.createElement(Button, { type: 'info', size: 'md-h', style: { width: isMobile() ? '100%' : 'auto' }, onClick: handleImportButton, disabled: showLoading },
                            React__default.createElement(IconLinkedInButton, { style: { marginRight: '10px' } }),
                            showLoading ? t('File uploading') : t('Import again'))))))),
        showDialog === 'guide' && (React__default.createElement(GuideDialog, { isOpen: showDialog === 'guide', onToggleOpen: function (e) { return setShowDialog(e); }, lang: lang })),
        showDialog === 'upload' && (React__default.createElement(UploadDialog, { type: type, isOpen: showDialog === 'upload', isLoading: showLoading, isSuccess: success, showErrorMess: showErrorMess, onToggleOpen: function (e) { return setShowDialog(e); }, onCvUploadLoading: function (cv) { return uploadLinkedInCV(cv); }, onCvUpload: function (e) { return setCvName(e); }, onReloadPage: function (e) { return handleReloadPage(e); }, onChangeLoading: function (e) { return setShowLoading(e); }, onChangeError: function (e) { return handleShowError(e); }, onCloseDialog: function () { return handleShowSuccess(false); }, onMyProfileClick: function () { return handleShowSuccess(false); }, error: error, lang: lang, baseUrl: baseUrl }))));
}

export { LinkedIn as default };
//# sourceMappingURL=index.js.map
